// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".relatedDocumentSelectKeyin {\n  display: inline-block;\n  width: 30% !important;\n  vertical-align: top;\n}\n.relatedDocumentInputKeyin {\n  display: inline-block;\n  width: 70% !important;\n}", ""]);
// Exports
module.exports = exports;
